import { render } from "./AccountRedirect.vue?vue&type=template&id=4de203d2"
import script from "./AccountRedirect.vue?vue&type=script&lang=js"
export * from "./AccountRedirect.vue?vue&type=script&lang=js"
script.render = render

export default script